import * as actions from './actions';
import api from 'api/ApiClient';
import { call, put } from 'redux-saga/effects';

export function* fetchSplitTreatments(action, apiClient = api) {
  try {
    const treatments = yield call(apiClient.fetchSplitTreatments);
    yield put(actions.splitTreatmentsFetchSuccess(treatments));
  } catch (e) {
    yield put(actions.splitTreatmentsFetchError(e.message));
  }
}
